import { useMemo } from "react";
import { useBrands } from "./useBrands";
import { Brand } from "@unleashed/models/Brand";
import { Park } from "@unleashed/models/Park";

export const useLocations = (brandSlug?: string, locationSlug?: string) => {
  const brands = useBrands(brandSlug);

  return useMemo(() => {
    return brands
      .map(b => b.locations?.map(l => ({
        ...l,
        id: l.id ?? "all",
        brand: {
          id: b.id,
          abbreviation: b.abbreviation,
          urlSlug: b.urlSlug
        } as Brand
      }) as Park))
      .reduce((a, b) => a?.concat(b??[]), [])
      ?.filter(l => !locationSlug || l.urlSlug === locationSlug) ?? [];
  }, [brands, locationSlug]);
};
